import { render } from "./AllTradesView.vue?vue&type=template&id=007b8330&scoped=true"
import script from "./AllTradesView.vue?vue&type=script&lang=js"
export * from "./AllTradesView.vue?vue&type=script&lang=js"

import "./AllTradesView.vue?vue&type=style&index=0&id=007b8330&lang=scss&scoped=true"

import exportComponent from "C:\\Projects\\fxhub-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-007b8330"]])

export default __exports__